import loginTgclub from './login';
import loginShanxian from './shanxian';
import { common } from '@tencent/ceiba-base-components';

const IN_SHANXIAN_APP = 'spark_open';

function getHandler() {
  // 心悦里面临时兼容闪现登录态
  const isShanxian = common.tool.getQueryparams('via');
  console.log('isShanxian', isShanxian);
  if (IN_SHANXIAN_APP === isShanxian) return loginShanxian;
  return loginTgclub;
}

const loginPlugin = {
  install(Vue) {
    // Vue.prototype.$loginTgclubPlugin = {
    //   initLogin: login.initLogin,
    //   checkLogin: login.checkLogin,
    //   login: login.login,
    //   logout: login.logout,
    // };
    Vue.prototype.$loginTgclubPlugin = {
      initLogin: async params => await getHandler(Vue, 'initLogin').initLogin(params),
      checkLogin: async params => await getHandler(Vue, 'checkLogin').checkLogin(params),
      login: async params => await getHandler(Vue, 'login').login(params),
      logout: async params => await getHandler(Vue, 'logout').logout(params),
    };
  },
};
export default loginPlugin;
